import { CommonModule } from '@angular/common';
import { Component, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-cart-options',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './cart-options.component.html',
  styleUrl: './cart-options.component.scss'
})
export class CartOptionsComponent {
  @Output() sendChange = new EventEmitter<any>();
  public index: any = 1;

  ngOnInit() {
    this.setOption(1);

  }

  setOption(ix: any) {
    this.index = ix;
    this.sendChange.emit({option: ix});
  }
}
